import { useState } from "react";
import PracticeTest from "./components/PracticeTest";
import { StatsDisplay } from "./components/StatsDisplay";

type Modes = "Practice" | "Stats";

const activeColor = "bg-blue-200";
const inactiveColor = "";
const standard = "p-2";

export default function App() {
    const [ mode, setMode ] = useState<Modes>("Practice");

    return (
        <div className="flex flex-col h-svh">
            <div className="flex flex-col">
                <div className="p-0 bg-slate-100 font-bold border-b-1 border-b-slate-200 flex flex-row ">
                    <span className={`${mode === "Practice" ? activeColor : inactiveColor} ${standard}`} onClick={() => { setMode("Practice")}}>Practice</span>                    
                    <span className={`${mode === "Stats" ? activeColor : inactiveColor} ${standard}`} onClick={() => { setMode("Stats")}}>Stats</span>                    
                </div>
            </div>
            <div className="flex-grow overflow-y-hidden">
                { mode === "Practice" && <PracticeTest/> }
                { mode === "Stats" && <StatsDisplay/> }
            </div>

        </div>
    )
}